module.exports = __webpack_public_path__ + "static/quote_2-139c657936c0649019619ea9ac22beab.png";